import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'temptik-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartComponent {}
